import { render, staticRenderFns } from "./NordThemePage.vue?vue&type=template&id=2985c736&"
import script from "./NordThemePage.vue?vue&type=script&lang=js&"
export * from "./NordThemePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2985c736')) {
      api.createRecord('2985c736', component.options)
    } else {
      api.reload('2985c736', component.options)
    }
    module.hot.accept("./NordThemePage.vue?vue&type=template&id=2985c736&", function () {
      api.rerender('2985c736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordThemePage.vue"
export default component.exports